import {
  Chats,
  Images,
  SummaryTable,
  ImagesWithDepartments,
  ChatsWithDepartments,
} from "@shared-components/core-metrics";
import type { GranularityType } from "@shared-server/api/routers/queries/metrics/utils";

type SummaryChatsAndImagesProps = {
  startDate: Date;
  endDate: Date;
  granularity: GranularityType;
};

export const SummaryChatsAndImages = (props: SummaryChatsAndImagesProps) => {
  return (
    <>
      <SummaryTable startDate={props.startDate} endDate={props.endDate} />
      <Chats
        startDate={props.startDate}
        endDate={props.endDate}
        granularity={props.granularity}
      />
      <Images
        startDate={props.startDate}
        endDate={props.endDate}
        granularity={props.granularity}
      />
      <hr />
      <div className="flex row gap-3 items-center mt-3">
        <h2 className="mb-4">{"Departments categorization"}</h2>
      </div>
      <ChatsWithDepartments
        startDate={props.startDate}
        endDate={props.endDate}
        granularity={props.granularity}
      />
      <ImagesWithDepartments
        startDate={props.startDate}
        endDate={props.endDate}
        granularity={props.granularity}
      />
    </>
  );
};
